import { toNumber } from './likertHelpers';

// Faixas padrão de classificação da favorabilidade (top-2 box).
// O back pode sobrescrever os limites enviando `faixas` no endpoint.
export const FAVORABILIDADE_FAIXAS = [
  {
    codigo: 'critica',
    color: '#e53935',
    labelId: 'labelFavorabilidadeCritica',
    limiteInferior: 0,
    limiteSuperior: 50,
  },
  {
    codigo: 'atencao',
    color: '#f5a119',
    labelId: 'labelFavorabilidadeAtencao',
    limiteInferior: 50,
    limiteSuperior: 65,
  },
  {
    codigo: 'boa',
    color: '#61aa50',
    labelId: 'labelFavorabilidadeBoa',
    limiteInferior: 65,
    limiteSuperior: 80,
  },
  {
    codigo: 'excelente',
    color: '#2e7d32',
    labelId: 'labelFavorabilidadeExcelente',
    limiteInferior: 80,
    limiteSuperior: 100,
  },
];

const normalizeCode = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const getFaixasFavorabilidade = (faixas) => {
  if (!Array.isArray(faixas) || faixas.length === 0) {
    return FAVORABILIDADE_FAIXAS;
  }

  const personalizadas = faixas
    .map((faixa) => {
      const padrao = FAVORABILIDADE_FAIXAS.find(
        (item) => item.codigo === normalizeCode(faixa.codigo)
      );

      if (!padrao) return null;

      return {
        ...padrao,
        color: faixa.cor || padrao.color,
        limiteInferior:
          faixa.limiteInferior == null
            ? padrao.limiteInferior
            : toNumber(faixa.limiteInferior),
        limiteSuperior:
          faixa.limiteSuperior == null
            ? padrao.limiteSuperior
            : toNumber(faixa.limiteSuperior),
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.limiteInferior - b.limiteInferior);

  return personalizadas.length ? personalizadas : FAVORABILIDADE_FAIXAS;
};

export const getFaixaFavorabilidade = (valor, faixas) => {
  const lista = getFaixasFavorabilidade(faixas);
  const numero = toNumber(valor);

  const encontrada = lista.find((faixa, index) =>
    index === lista.length - 1
      ? numero >= faixa.limiteInferior && numero <= faixa.limiteSuperior
      : numero >= faixa.limiteInferior && numero < faixa.limiteSuperior
  );

  return encontrada || lista[0];
};

// Limites usados como marcações da régua do gauge: 0, cada corte e 100.
export const getLimitesFavorabilidade = (faixas) => {
  const lista = getFaixasFavorabilidade(faixas);

  return [
    lista[0].limiteInferior,
    ...lista.map((faixa) => faixa.limiteSuperior),
  ];
};
